import { makeNavTrackingButton } from './makeNavTrackingButton'

export const TrackedToggle = makeNavTrackingButton('hamburger')
